import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

export default function Map() {
  return (
    <Layout>
      <SEO title="Home" />
      <h1 className="text-center">
        Stop Sacramento from "UN"planning our Communities!
      </h1>
      <p className="text-center">
        WE WILL NOT STAND FOR THIS LOSS OF LOCAL CONTROL AND UNFUNDED MANDATES
        BEING IMPOSED ON US BY OUR STATE.
      </p>
      <p>
        Sacramento Legislators continue their attack on Cities ability to manage
        their own land-use and zoning. And CCLC is continuing our efforts to
        bring attention to the bills that impact cities in this way, and instead
        support bills that encourage desired behaviors, while respecting the
        individuality of Cities.
      </p>
      <p>
        California Cities for Local Control is a grassroots organization that
        was founded in July 2020 by Torrance City Council Member Mike Griffiths.
        We are an advocacy group for local control over zoning and land use
        decisions. Councilmember Griffiths has assembled a volunteer
        organization from all around California, including other elected
        officials, homeowner group representatives, city planners, and
        passionate homeowners, all sharing the common belief that Local
        Governments should remain the ultimate decision makers for how their own
        communities are built.
      </p>
      <p>
        Our volunteers continually reach out to all elected Mayors and
        Councilmembers in every city in California, and to identify those
        elected officials who feel the same way about how our cities are
        managed. We believe that joining like-minded elected officials together
        around a common mission will send a strong, united statement to those
        involved in the state bill-making process. This is a massive undertaking
        that no other organization has attempted. But we believe that this goal
        is worth the effort.
      </p>
      <h2 className="text-center">Mission</h2>
      <p>
        Our mission is to spread awareness and enlist support to ensure that
        Cities can continue to manage their own land use and zoning issues. We
        must not allow the State Legislature to mandate changes to our Cities
        that will remove local control and be detrimental to our communities.
      </p>
      <p>
        We do this by reaching out to California City Elected Officials to
        educate and enlist them to our cause. Our activities include, but are
        not limited to, signing onto petitions, having Cities pass resolutions
        in support of our efforts, and seeking out allies for possible legal
        action against the State and/or to promote efforts for a ballot
        initiative to legislate the desired results.
      </p>
      <p>
        With this alliance of City Elected Officials working together as one, we
        stand a better chance of having our message resonate loud and clear to
        all groups that proclaim to support us.
      </p>
      <p>
        Here is a simple list of how each member voted on SB79. Are your
        representatives for Local Control?{" "}
      </p>
    </Layout>
  )
}
